/* eslint-disable no-empty-function */
/* eslint-disable complexity */
/* eslint-disable max-params */
/* eslint-disable max-lines-per-function */
(function() {
  'use strict';

  angular
    .module('webAgro1App')
    .controller('PropriedadeCalendarCtrl', PropriedadeCalendar);

  PropriedadeCalendar.$inject = [
    '$rootScope',
    'HistoricosService',
    '$scope',
    '$timeout',
    'DataService'
  ];

  function PropriedadeCalendar($rootScope, HistoricosService, $scope, $timeout, DataService) {
    const vm = this;

    //////////////////////////////////////////
    // Controller data
    vm.datePickerOptions = {
      showWeeks: false,
      customClass: (obj) => DataService.getDatePickerCustomClass(obj, vm.dates)
    };
    vm.glebas = $rootScope.currentPropriedade.glebas;
    vm.dates = null;
    vm.selectedDate = null;

    // Next values come from directive scope, bound to controller
    vm.filters = {
      date: null,
      gleba: null,
      cultura: null,
      operacao: null,
      usuario: null,
      cultivar: null
    };
    vm.disabled = false;
    vm.onChange = () => {};
    vm.sharedData = {
      culturas: [],
      operacoes: [],
      usuariosWithHistory: [],
      cultivares: []
    };

    //////////////////////////////////////////
    // Bindable methods
    vm.setValue = setValue;
    vm.setDate = setDate;
    vm.clearDate = clearDate;
    vm.getCultivares = getCultivares;

    //////////////////////////////////////////
    // Function declarations

    function isCultivarSelected(filters) {
      return filters.cultivar && filters.cultivar.item_id !== 'todas';
    }

    function getDatas() {
      return HistoricosService.getDatas({
        usuario: (vm.filters.usuario || {}).id,
        gleba: (vm.filters.gleba || {}).id,
        tipo: (vm.filters.operacao || {}).id,
        ocorrencia: (vm.filters.ocorrencia || {}).id,
        atividade: (vm.filters.cultura || {}).id,
        cultivar: isCultivarSelected(vm.filters) ? vm.filters.cultivar.item_id : null
      }).then((dates) => {
        vm.dates = dates;
        $timeout(() => $scope.$broadcast('refreshDatepickers'));
      });
    }

    function updateFilters(data = vm.filters) {
      vm.onChange({ data });
    }

    function setValue(type, value) {
      if (type === 'cultura') {
        updateFilters({
          ...vm.filters,
          cultivar: null,
          [type]: value
        });
      } else {
        updateFilters({
          ...vm.filters,
          [type]: value
        });
      }
      $timeout(getDatas);
    }

    function setDate() {
      updateFilters({
        ...vm.filters,
        date: vm.selectedDate
      });
    }

    function clearDate() {
      updateFilters({
        date: null,
        gleba: null,
        cultura: null,
        operacao: null,
        usuario: null,
        cultivar: null
      });
    }

    function getCultivares() {
      if (vm.filters.cultura) {
        return vm.sharedData.cultivares.filter((c) => (c.atividade || {}).id === vm.filters.cultura.id);
      }
      return vm.sharedData.cultivares;
    }

    //////////////////////////////////////////
    // Controller logic

    $scope.$on('glebaDblClick', (event, { gleba }) => setValue('gleba', gleba));

    $scope.$watch('calendar.filters.date', (newValue) => {
      if (typeof newValue !== 'string') {
        vm.selectedDate = newValue;
      } else {
        vm.selectedDate = null;
      }
    });

    $scope.$watch('calendar.sharedData', (newVal) => {
      if (Object.keys(newVal).some((key) => !!newVal[key].length)) {
        getDatas();
      }
    });

    $scope.$watch('calendar.filters.cultivar', (newVal) => {
      $rootScope.$broadcast('cultivarFilterChanged', newVal);
    });

    $scope.$on('calendarLoadDates', getDatas);
  }
}());
